import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { unlockAudio } from "@/lib/sound";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/HeroSequence";
import Science from "@/components/Science";
import Products from "@/components/Products";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminInbox from "@/components/AdminInbox";
import BackToTop from "@/components/BackToTop";
import AgeGate from "@/components/AgeGate";
import Cursor from "@/components/Cursor";
import SlashTrail from "@/components/SlashTrail";
import LabCTA from "@/components/LabCTA";
import LabPage from "@/components/LabPage";
import MembersLounge from "@/components/MembersLounge";
import SectionReveal from "@/components/SectionReveal";
import SectionSlash from "@/components/SectionSlash";
import { TransitionProvider } from "@/components/PageTransition";
import { scrollToSection } from "@/lib/scroll";

function Landing() {
  useEffect(() => {
    const target = sessionStorage.getItem("toji_scroll_target");
    if (!target) return;
    let tries = 0;
    const id = setInterval(() => {
      tries += 1;
      const el = document.getElementById(target);
      const gateGone = !document.querySelector('[data-testid="age-gate"]');
      if (el && window.__lenis && gateGone) {
        clearInterval(id);
        sessionStorage.removeItem("toji_scroll_target");
        const doScroll = () => {
          if (window.__lenis?.resize) window.__lenis.resize();
          scrollToSection(target);
        };
        setTimeout(doScroll, 250);
        setTimeout(doScroll, 900);
        setTimeout(doScroll, 1700);
      } else if (tries > 150) {
        sessionStorage.removeItem("toji_scroll_target");
        clearInterval(id);
      }
    }, 200);
    return () => clearInterval(id);
  }, []);

  return (
    <SmoothScroll>
      <div className="App grain sumi relative bg-[#050505]">
        <AgeGate />
        <Cursor />
        <SlashTrail />
        <Navbar />
        <main>
          <Hero />
          <SectionSlash />
          <SectionReveal>
            <Science />
          </SectionReveal>
          <SectionSlash />
          <SectionReveal>
            <Products />
          </SectionReveal>
          <SectionSlash />
          <SectionReveal>
            <LabCTA />
          </SectionReveal>
          <SectionSlash />
          <Contact />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </SmoothScroll>
  );
}

function App() {
  useEffect(() => {
    document.title = "Toji Peptides";
    const unlock = () => unlockAudio();
    window.addEventListener("pointerdown", unlock);
    window.addEventListener("keydown", unlock);
    window.addEventListener("wheel", unlock, { passive: true });
    window.addEventListener("touchstart", unlock, { passive: true });
    return () => {
      window.removeEventListener("pointerdown", unlock);
      window.removeEventListener("keydown", unlock);
      window.removeEventListener("wheel", unlock);
      window.removeEventListener("touchstart", unlock);
    };
  }, []);
  return (
    <BrowserRouter>
      <TransitionProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/lab" element={<LabPage />} />
          <Route path="/members" element={<MembersLounge />} />
          <Route path="/admin" element={<AdminInbox />} />
        </Routes>
      </TransitionProvider>
    </BrowserRouter>
  );
}

export default App;
